var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-custom-mask"},[_c('div',{staticClass:"modal-custom-wrapper"},[_c('div',{staticClass:"modal-custom-container"},[_c('div',{staticClass:"modal-custom-body"},[_vm._t("body",[_vm._v("\n            default body\n          ")])],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7149fc61","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ISOModal.vue
// module id = null
// module chunks = 